/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	GetDataStream200,
	GetDataStream400,
	GetDataStream404,
	GetDataStream500,
	ListDataStreamPoints200,
	ListDataStreamPoints400,
	ListDataStreamPoints403,
	ListDataStreamPoints404,
	ListDataStreamPoints500,
	ListDataStreamPointsParams,
	ListDataStreams200Item,
	ListDataStreams400,
	ListDataStreams500,
	ListDataStreamsParams,
	ListMultiStreamDataPoints200,
	ListMultiStreamDataPoints400,
	ListMultiStreamDataPoints403,
	ListMultiStreamDataPoints500,
	ListMultiStreamDataPointsParams,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListDataStreamsUrl = (params?: ListDataStreamsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams?${stringifiedParams}`
		: `/data-streams`;
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const listDataStreams = async (
	params?: ListDataStreamsParams,
	options?: RequestInit,
): Promise<ListDataStreams200Item[]> => {
	return customFetch<ListDataStreams200Item[]>(getListDataStreamsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListDataStreamsQueryKey = (params?: ListDataStreamsParams) => {
	return ["data-streams", ...(params ? [params] : [])] as const;
};

export const getListDataStreamsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListDataStreamsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataStreams>>> = ({
		signal,
	}) => listDataStreams(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreams>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreams>>
>;
export type ListDataStreamsQueryError = ListDataStreams400 | ListDataStreams500;

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params: undefined | ListDataStreamsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useSetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListDataStreamsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreams>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreams>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreams>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listDataStreams>>>(
			{ queryKey: getListDataStreamsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useGetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListDataStreamsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreams>>>(
			getListDataStreamsQueryKey(params),
		);
};

export const getGetDataStreamUrl = (streamId: number) => {
	return `/data-streams/${streamId}`;
};

/**
 * @summary Get a single data stream by ID
 */
export const getDataStream = async (
	streamId: number,
	options?: RequestInit,
): Promise<GetDataStream200> => {
	return customFetch<GetDataStream200>(getGetDataStreamUrl(streamId), {
		...options,
		method: "GET",
	});
};

export const getGetDataStreamQueryKey = (streamId: number) => {
	return ["data-streams", streamId] as const;
};

export const getGetDataStreamQueryOptions = <
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDataStreamQueryKey(streamId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataStream>>> = ({
		signal,
	}) => getDataStream(streamId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getDataStream>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDataStreamQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDataStream>>
>;
export type GetDataStreamQueryError =
	| GetDataStream400
	| GetDataStream404
	| GetDataStream500;

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single data stream by ID
 */

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetDataStreamQueryOptions(streamId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single data stream by ID
 */
export const useSetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		updater:
			| Awaited<ReturnType<typeof getDataStream>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getDataStream>> | undefined,
			  ) => Awaited<ReturnType<typeof getDataStream>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getDataStream>>>(
			{ queryKey: getGetDataStreamQueryKey(streamId) },
			updater,
		);
	};
};

/**
 * @summary Get a single data stream by ID
 */
export const useGetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getDataStream>>>(
			getGetDataStreamQueryKey(streamId),
		);
};

export const getListDataStreamPointsUrl = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams/${streamId}/data-points?${stringifiedParams}`
		: `/data-streams/${streamId}/data-points`;
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const listDataStreamPoints = async (
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: RequestInit,
): Promise<ListDataStreamPoints200> => {
	return customFetch<ListDataStreamPoints200>(
		getListDataStreamPointsUrl(streamId, params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListDataStreamPointsQueryKey = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	return [
		"data-streams",
		streamId,
		"data-points",
		...(params ? [params] : []),
	] as const;
};

export const getListDataStreamPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListDataStreamPointsQueryKey(streamId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listDataStreamPoints>>
	> = ({ signal }) =>
		listDataStreamPoints(streamId, params, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreamPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreamPoints>>
>;
export type ListDataStreamPointsQueryError =
	| ListDataStreamPoints400
	| ListDataStreamPoints403
	| ListDataStreamPoints404
	| ListDataStreamPoints500;

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params: undefined | ListDataStreamPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamPointsQueryOptions(
		streamId,
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useSetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		params: ListDataStreamPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreamPoints>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreamPoints>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreamPoints>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listDataStreamPoints>>
		>({ queryKey: getListDataStreamPointsQueryKey(streamId, params) }, updater);
	};
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useGetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number, params?: ListDataStreamPointsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreamPoints>>>(
			getListDataStreamPointsQueryKey(streamId, params),
		);
};

export const getListMultiStreamDataPointsUrl = (
	params: ListMultiStreamDataPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-points?${stringifiedParams}`
		: `/data-points`;
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const listMultiStreamDataPoints = async (
	params: ListMultiStreamDataPointsParams,
	options?: RequestInit,
): Promise<ListMultiStreamDataPoints200> => {
	return customFetch<ListMultiStreamDataPoints200>(
		getListMultiStreamDataPointsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListMultiStreamDataPointsQueryKey = (
	params?: ListMultiStreamDataPointsParams,
) => {
	return ["data-points", ...(params ? [params] : [])] as const;
};

export const getListMultiStreamDataPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListMultiStreamDataPointsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>
	> = ({ signal }) =>
		listMultiStreamDataPoints(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPoints>>
>;
export type ListMultiStreamDataPointsQueryError =
	| ListMultiStreamDataPoints400
	| ListMultiStreamDataPoints403
	| ListMultiStreamDataPoints500;

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useSetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListMultiStreamDataPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
						| undefined,
			  ) => Awaited<ReturnType<typeof listMultiStreamDataPoints>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>({ queryKey: getListMultiStreamDataPointsQueryKey(params) }, updater);
	};
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useGetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (params: ListMultiStreamDataPointsParams) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>(getListMultiStreamDataPointsQueryKey(params));
};
